import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { roleBadgeClass, roleLabel } from '@/lib/roles'
import { apiErrorMessage, teamService, TeamMember } from '@/services/team-service'
import * as toast from '@/lib/toast'
import { RoleSelect } from './RoleSelect'
import { UserOabsEditor } from './UserOabsEditor'

interface TeamMembersTableProps {
  members: TeamMember[]
  currentUserId?: string
  canEdit: boolean
  onChanged: () => void
}

/** Equipe: papel (Sócio/Advogado/Assistente/Agente) e OABs de cada pessoa. */
export function TeamMembersTable({ members, currentUserId, canEdit, onChanged }: TeamMembersTableProps) {
  const changeRole = async (member: TeamMember, role: string) => {
    try {
      await teamService.changeRole(member.id, role)
      toast.success(`${member.fullName}: papel alterado para ${roleLabel(role)}`, 'Vale a partir do próximo login.')
      onChanged()
    } catch (error) {
      toast.error(apiErrorMessage(error))
    }
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Pessoa</TableHead>
          <TableHead className="w-44">Papel</TableHead>
          <TableHead>OABs</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {members.map((member) => (
          <TableRow key={member.id}>
            <TableCell>
              <div className="font-medium">{member.fullName}</div>
              <div className="text-xs text-muted-foreground">{member.email}</div>
            </TableCell>
            <TableCell>
              {canEdit && member.id !== currentUserId ? (
                <RoleSelect
                  role={member.role}
                  aria-label={`Papel de ${member.fullName}`}
                  onChange={(role) => changeRole(member, role)}
                />
              ) : (
                <Badge variant="outline" className={roleBadgeClass(member.role)}>
                  {roleLabel(member.role)}
                </Badge>
              )}
            </TableCell>
            <TableCell>
              <UserOabsEditor userId={member.id} oabs={member.oabs} canEdit={canEdit} onChanged={onChanged} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
